import {BASE_URL} from '@/utils/config';
import {axiosPublic} from '@/service/axios'; // authenticated instance

const URL = `${BASE_URL}/yellow-pages`;

// ─── Categories ───────────────────────────────────────────────────────────────

export const fetchCategories = async () => {
	try {
		const response = await axiosPublic.get(`${URL}/categories`);
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) fetchCategories Error: ", error);
	}
};

// ─── Entity CRUD ──────────────────────────────────────────────────────────────

export const createEntity = async (axiosInstance, formData, logoFile) => {
	try {
		const fd = new FormData();
		fd.append('entityData', JSON.stringify(formData));
		if (logoFile) fd.append('logo', logoFile);

		const response = await axiosInstance.post(`${URL}/entity`, fd, {
			headers: {'Content-Type': 'multipart/form-data'}
		});
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) createEntity Error: ", error);
	}
};

export const getMyEntities = async (axiosInstance) => {
	try {
		const response = await axiosInstance.get(`${URL}/my-entities`);
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) getMyEntities Error: ", error);
	}
};

export const getEntityProfile = async (axiosInstance, entityId) => {
	try {
		const response = await axiosInstance.get(`${URL}/entity/${entityId}`);
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) getEntityProfile Error: ", error);
	}
};

export const getEntityPublicProfile = async (entityId) => {
	try {
		const response = await axiosPublic.get(`${URL}/entity/${entityId}/public`);
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) getEntityPublicProfile Error: ", error);
	}
};

export const updateEntityProfile = async (axiosInstance, entityId, updateData) => {
	try {
		const response = await axiosInstance.put(`${URL}/entity/${entityId}`, updateData);
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) updateEntityProfile Error: ", error);
	}
};

export const togglePublishEntity = async (axiosInstance, entityId) => {
	try {
		const response = await axiosInstance.patch(`${URL}/entity/${entityId}/toggle-publish`);
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) togglePublishEntity Error: ", error);
	}
};

export const deleteEntity = async (axiosInstance, entityId, reason) => {
	try {
		const response = await axiosInstance.delete(`${URL}/entity/${entityId}`, {
			data: {reason}
		});
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) deleteEntity Error: ", error);
	}
};

// ─── Media Upload ─────────────────────────────────────────────────────────────

export const uploadEntityMedia = async (axiosInstance, entityId, file, type, caption = '') => {
	try {
		const fd = new FormData();
		fd.append('file', file);
		fd.append('type', type);       // 'logo' | 'portfolio'
		if (caption) fd.append('caption', caption);

		const response = await axiosInstance.post(`${URL}/entity/${entityId}/upload-media`, fd, {
			headers: {'Content-Type': 'multipart/form-data'}
		});
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) uploadEntityMedia Error: ", error);
	}
};

// ─── Search + Landing Page ────────────────────────────────────────────────────

export const searchEntities = async (params) => {
	try {
		const response = await axiosPublic.get(`${URL}/search`, {params});
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) searchEntities Error: ", error);
	}
};

export const getFeaturedEntities = async (limit = 6) => {
	try {
		const response = await axiosPublic.get(`${URL}/featured`, {params: {limit}});
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) getFeaturedEntities Error: ", error);
	}
};

export const getNewestEntities = async (limit = 6) => {
	try {
		const response = await axiosPublic.get(`${URL}/newest`, {params: {limit}});
		return response.data;
	} catch (error) {
		console.error("(yellowPageApi.js) getNewestEntities Error: ", error);
	}
};